"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FederalWithholdingCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_native_1 = require("react-native");
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const Field_1 = __importDefault(require("../components/Field"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const Button_1 = __importDefault(require("../components/Button"));
const UserContext_1 = require("../contexts/UserContext");
const react_i18next_1 = require("react-i18next");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        exemptLabel: {
            color: THEME.Text,
            backgroundColor: THEME.Warning,
            borderRadius: 2,
            paddingHorizontal: 4,
            paddingVertical: 2
        }
    });
};
;
function FederalWithholdingCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const styles = useStyles();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    let usaDollarNoDecimal = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });
    let usaDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    let displayFields = [
        "filingStatus",
        "deductions",
        "dependentCredits",
        "extraWithholding",
        "exempt",
        "multipleJobs",
        "otherIncome",
        "withholdingAllowances",
    ];
    const renderDisplayFields = ({ item }) => {
        switch (item) {
            case "filingStatus":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:labels.fStatus'), value: props.federalTaxes?.filingStatus ?? "—" }));
            case "deductions":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:text.deduct'), value: (props.federalTaxes?.deductions != null && props.federalTaxes.deductions != 0) ? usaDollarNoDecimal.format(props.federalTaxes.deductions) : "—" }));
            case "dependentCredits":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:text.dependentCredits'), value: (props.federalTaxes?.dependentCredits != null && props.federalTaxes.dependentCredits != 0) ? usaDollarNoDecimal.format(props.federalTaxes.dependentCredits) : "—" }));
            case "extraWithholding":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:labels.extWithholding'), value: (props.federalTaxes?.extraWithholding != null && props.federalTaxes.extraWithholding != 0) ? usaDollar.format(props.federalTaxes.extraWithholding) : "—" }));
            case "exempt":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:labels.exempt'), value: props.federalTaxes?.isExempt == true ? t('common:text.yes') : t('common:text.no') }));
            case "multipleJobs":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:labels.mJobs'), value: props.federalTaxes?.isMultipleJobs == true ? t('common:text.yes') : t('common:text.no') }));
            case "otherIncome":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:text.otherIncome'), value: (props.federalTaxes?.otherIncome != null && props.federalTaxes.otherIncome != 0) ? usaDollar.format(props.federalTaxes.otherIncome) : "—" }));
            case "withholdingAllowances":
                return ((0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('myPay:labels.withholdingAllowances'), value: (props.federalTaxes?.withholdingAllowances != null && props.federalTaxes.withholdingAllowances != 0) ? props.federalTaxes.withholdingAllowances.toString() : "—" }));
        }
    };
    const editFederalWithholding = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Prism SSO - Edit Taxes',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        props.navigation.navigate('UpdateTaxes');
    };
    (0, react_1.useEffect)(() => {
        return () => {
            react_native_1.DeviceEventEmitter.removeAllListeners("event.federalW4Update");
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.federalTaxes?.isExempt == true
            &&
                (0, jsx_runtime_1.jsx)(Card_1.default, { children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                            fontSize: 18,
                                            fontWeight: '500',
                                            color: THEME.Text
                                        }, children: t('myPay:text.federalWithholding') }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.exemptLabel, { alignSelf: 'flex-start', marginTop: 4 }], accessible: true, "aria-label": t('myPay:labels.exempt'), children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: { fontSize: (size != 'sm' ? 16 : 12), color: THEME.AlwaysWhite, fontWeight: '500' }, children: t('myPay:labels.exempt').toUpperCase() }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsxs)(Button_1.default, { type: "outline", accessibilityHint: t('common:buttons.edit') + " " + t('myPay:text.federalWithholding'), onPress: editFederalWithholding, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('common:buttons.edit') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.Pen, size: 14, style: { marginRight: 6 } })] }) })] }) })
            ||
                (0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('myPay:text.federalWithholding'), style: { marginBottom: 0 }, children: props.status == 'done' &&
                                (0, jsx_runtime_1.jsxs)(Button_1.default, { type: "outline", accessibilityHint: t('common:buttons.edit') + " " + t('myPay:text.federalWithholding'), onPress: editFederalWithholding, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('common:buttons.edit') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.Pen, size: 14, style: { marginRight: 6 } })] }) }), (props.status == 'done') &&
                            (0, jsx_runtime_1.jsx)(FadeInView_1.default, { children: (0, jsx_runtime_1.jsx)(MasonryList_1.default, { columns: 2, data: displayFields, renderItem: renderDisplayFields, style: { marginVertical: 0, marginHorizontal: 0 } }) }), (props.status == 'loading' || props.status == 'error') &&
                            (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: props.status == 'loading', error: props.status == 'error' })] }) }));
}
